// ===========================================================================
// Executive Financial Dashboard (Module K) — fake data determinístico.
//
// Backend futuro (según docs/modulos/BillingV2/MODULO_K_EXECUTIVE_FINANCIAL_DASHBOARD.md):
//   GET /api/finance/period?months=12        → finance.TAB_FINANCIAL_PERIOD (parser LAB8R)
//   GET /api/finance/mlr-drivers             → finance.TAB_MLR_DRIVERS
//   GET /api/finance/module-impact           → finance.TAB_MODULE_IMPACT
//
// Mientras no exista el schema `finance`, estos valores modelan el reporte
// LAB8R conocido: MLR 94.3% vs meta 86%, déficit YTD −$7.14M.
// ===========================================================================

/** Meta de MLR del contrato (Quality Gate). */
export const MLR_TARGET = 86.0;

/**
 * Serie mensual de MLR (LAB8R). Futuro: GET /api/finance/period?months=12
 */
export const FAKE_MLR_BY_MONTH = [
  { month: "2025-06", mlr: 92.1 },
  { month: "2025-07", mlr: 93.0 },
  { month: "2025-08", mlr: 95.2 },
  { month: "2025-09", mlr: 94.8 },
  { month: "2025-10", mlr: 93.9 },
  { month: "2025-11", mlr: 94.6 },
  { month: "2025-12", mlr: 95.1 },
  { month: "2026-01", mlr: 93.2 },
  { month: "2026-02", mlr: 93.8 },
  { month: "2026-03", mlr: 94.5 },
  { month: "2026-04", mlr: 94.9 },
  { month: "2026-05", mlr: 94.3 },
];

/** Métricas financieras de cabecera (LAB8R). */
export const FAKE_FINANCIALS = {
  mlr: 94.3,
  netMarginPct: -5.8,
  revenuePmpm: 301, // premium PMPM promedio
  deficitYtd: -7140000,
  riskScore: 1.247,
};

/**
 * Tendencia MoM (%) por driver de costo. Futuro: GET /api/finance/mlr-drivers
 * Keys alineadas al breakdown real de cost/summary.json.
 */
export const FAKE_DRIVER_TRENDS = {
  inpatient: 6.2,
  outpatient: 1.9,
  er: 3.1,
  professional: -0.8,
  pharmacy: 4.8,
  other: -2.3,
};

/**
 * Breakdown de costo fallback (mismo shape que cost/summary.json.breakdown)
 * si el JSON real no carga.
 */
export const FAKE_COST_BREAKDOWN = [
  { costType: "Inpatient Cost", cost: 16378560, percentage: 46.0 },
  { costType: "Outpatient Cost", cost: 7237654, percentage: 20.3 },
  { costType: "Pharmacy Cost", cost: 5725596, percentage: 16.1 },
  { costType: "Professional Cost", cost: 3540261, percentage: 9.9 },
  { costType: "Emergency Room Cost", cost: 2340102, percentage: 6.6 },
  { costType: "Ancillary Cost", cost: 343595, percentage: 1.0 },
  { costType: "Virtual Visit Cost", cost: 33133, percentage: 0.1 },
];

/**
 * Palancas de revenue ligadas a módulos operativos.
 * Futuro: GET /api/finance/module-impact (finance.TAB_MODULE_IMPACT).
 */
export const FAKE_REVENUE_LEVERS = [
  {
    key: "hcc_recapture",
    label: "HCC recapture",
    module: "MOD E",
    description: "Dropped / suspect HCC conditions pending recapture",
    annualOpportunity: 2400000,
    capturedYtd: 310000,
  },
  {
    key: "missing_charges",
    label: "Missing charge capture",
    module: "MOD N",
    description: "Rendered services without a posted charge",
    annualOpportunity: 1100000,
    capturedYtd: 185000,
  },
  {
    key: "denial_prevention",
    label: "Denial prevention & recovery",
    module: "MOD G",
    description: "Avoidable denials and recoverable write-offs",
    annualOpportunity: 850000,
    capturedYtd: 96000,
  },
];
